import { render, staticRenderFns } from "./scene3.vue?vue&type=template&id=21cf8514&scoped=true&"
import script from "./scene3.vue?vue&type=script&lang=ts&"
export * from "./scene3.vue?vue&type=script&lang=ts&"
import style0 from "./scene3.vue?vue&type=style&index=0&id=21cf8514&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cf8514",
  null
  
)

export default component.exports